export const TERMS_OF_USE_PATH = '/terms_of_use';
